import Link from 'next/link'
import { NextSeo } from 'next-seo'
import { Typography } from '@evocolabs/orkaui'

import { classes } from '@/src/components/Blog/[blogTitle].module.js'

const DEFAULT_BLOG_URL = '/HearingBlog'

const BLOG_IMG_URL = 'https://legacy-cdn.hiorka.com/imgs/blog/'
const BANNER_PATH = 'banner/'
const SHARE_PATH = 'shareImgs/'

export const SEO = ({ title, description, imageUrl }) => (
  <NextSeo
    title={title}
    description={description}
    openGraph={{
      images: [
        {
          url: imageUrl
        }
      ]
    }}
  />
)

export const BlogBanner = ({ bannerUrl, usePC }) => (
  <picture
    style={{
      width: usePC ? '81.4%' : '92vw',
      height: 'auto',
      marginBottom: usePC ? '80px' : '40px',
      marginTop: usePC ? '80px' : '67px',
      maxWidth: '1172px'
    }}
  >
    <source srcSet={`${BLOG_IMG_URL}${SHARE_PATH}${bannerUrl}`} type="image/jpeg" media="(max-width: 1023px)" />
    <source srcSet={`${BLOG_IMG_URL}${BANNER_PATH}${bannerUrl}`} type="image/jpeg" media="(min-width: 1024px)" />
    <source srcSet={`${BLOG_IMG_URL}${bannerUrl}?webp`} type="image/webp" />
    <source srcSet={`${BLOG_IMG_URL}${bannerUrl}`} type="image/png" />
    <img src={`${BLOG_IMG_URL}${bannerUrl}`} style={{ display: 'block', width: '100%' }} />
  </picture>
)

export const BlogBreadcrumb = ({ theme }) => (
  <div style={{ displaly: 'flex', flexDirection: 'row' }}>
    <Link href={DEFAULT_BLOG_URL}>
      <Typography variant="Body3">{'Hearing Blog '}</Typography>
    </Link>
    <Typography className={classes.footPrints}>{'>'}</Typography>
    <Typography variant="Body3" color="#918D8C">
      {' ' + theme}
    </Typography>
  </div>
)
